import Axios from "axios";
import { Dispatch } from "redux";
import { FixMeLater } from "types/FixMeLaterType";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { CREATE_TARGET_GROUPS, DELETE_TARGET_GROUP, GET_TARGET_GROUP, GET_TARGET_GROUPS, GET_TARGET_GROUPS_BY_IDS, PREVIEW_TARGET_GROUP, RESET_CURRENT_TARGET_GROUP, UPDATE_CURRENT_TARGET_GROUP } from "../constants/action-types";

type Callback = (success: boolean) => void

const API_CONFIG = getApiConfig();

/* 
    Get Target Groups
*/
export const getTargetGroups = (
    modelType: string,
    callback: Callback
) => (dispatch: Dispatch) => {

    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/GetTargetGroups?ModelType=${modelType}`, {
        method: "get"
    }).then((res: FixMeLater) => {
        dispatch({
            type: GET_TARGET_GROUPS,
            payload: {
                modelType: modelType,
                data: res.data
            }
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/*
    Get Target Group
*/
export const getTargetGroup = (
    targetGroupId: string,
    callback: Callback
) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/GetGroupById?id=${targetGroupId}`, {
        method: "get"
    }).then((res: FixMeLater) => {
        dispatch({
            type: GET_TARGET_GROUP,
            payload: res.data
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/*
    Get Target Group from ids
*/
export const getTargetGroupsForIds = (
    targetGroupIds: string[],
    callback: Callback
) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/groups?forIds=true`, {
        method: "post",
        data: targetGroupIds
    }).then((res: FixMeLater) => {
        dispatch({
            type: GET_TARGET_GROUPS_BY_IDS,
            payload: res.data
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/* 
    Create Target Group
*/
export const createTargetGroup = (
    targetGroup: FixMeLater,
    callback: Callback
) => (dispatch: Dispatch) => {
    const headers = { "Content-Type": "application/json" }

    const jsonData = {
        "id": targetGroup.id != null ? targetGroup.id : undefined,
        "DisplayName": targetGroup.DisplayName,
        "ModelType": targetGroup.ModelType,
        "TokenField": targetGroup.TokenField,
        "SalesOrganisationIds": targetGroup.SalesOrganisationIds != null ? targetGroup.SalesOrganisationIds.map((item: FixMeLater) => item.trim()) : [],
        "ContainsAnyToken": targetGroup.ContainsAnyToken,
        "FilterRules": targetGroup.FilterRules,
        "CallType": targetGroup.CallType != null ? targetGroup.CallType : null
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/CreateTargetGroup`, {
        method: "post",
        headers: headers,
        data: jsonData
    }).then((res: FixMeLater) => {
        console.log(res)
        targetGroup.id = res.data.id
        dispatch({
            type: CREATE_TARGET_GROUPS,
            payload: targetGroup
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error.message}`);
        callback(false);
    })
};

/*
    Make a request to peek a specified target group and its impact.
*/
export const previewTargetGroup = (
    modelType: string,
    data: any,
    callback: Callback
) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/PreviewTargetGroup?modelType=${modelType}&targetGroup=${data}`, {
        method: "post"
    }).then((res: FixMeLater) => {
        dispatch({
            type: PREVIEW_TARGET_GROUP,
            payload: res.data
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error.message}`);
        callback(false);
    })
}

/*
    Update local state for current Target Group
*/

export const updateLocalTargetGroup = (
    targetGroup: FixMeLater, 
    callback: Callback
    ) => (dispatch: Dispatch) => {
    dispatch({
        type: UPDATE_CURRENT_TARGET_GROUP,
        payload: targetGroup
    });

    callback(true);
};

/*
    Reset local state for current Target Group
*/
export const resetLocalTargetGroup = (
    callback: Callback
    ) => (dispatch: Dispatch) => {
    dispatch({
        type: RESET_CURRENT_TARGET_GROUP,
        payload: null
    });

    callback(true);
}

/*
    Delete requested targetgroup via its identifier.
*/
export const deleteTargetGroup = (
    targetGroupId: string, 
    callback: Callback
    ) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/targeting/groups/${targetGroupId}`, {
        method: "delete"
    }).then((res: FixMeLater) => {
        dispatch({
            type: DELETE_TARGET_GROUP,
            payload: res.data
        });

        callback(true);
    }).catch((error: Error) => {
        console.log(`Exception Occurred: ${error.message}`);
        callback(false);
    })
}